/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable prefer-destructuring */
/* eslint-disable react/prop-types */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable no-return-assign */
/* eslint-disable react/no-array-index-key */
/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable no-param-reassign */
/* eslint-disable consistent-return */
/* eslint-disable no-unused-vars */
import React, { useEffect, useRef, useState } from 'react';
import { useIntl } from 'react-intl';
import { Row, Col, Overlay, Card } from 'react-bootstrap';
import differenceInCalendarDays from 'date-fns/differenceInCalendarDays';
import differenceInYears from 'date-fns/differenceInYears';
import addDays from 'date-fns/addDays';
import { CiBank, CiWallet } from 'react-icons/ci';
import {
  MdKeyboardArrowDown,
  MdKeyboardArrowUp,
  MdOutlineCreditCard,
} from 'react-icons/md';
import CheckforMobile from '../../shared/components/app-hidden/CheckforMobile';
import {
  formatCurrency,
  formatDate,
  getEligibilityForPaymentMode,
  getNewDate,
  isEmpty,
  scrollToTop,
} from '../../shared/helper-utils/appUtils';
import {
  API_DATE_FORMAT,
  TODAY_DATE,
  DATE_MONTH_YEAR_WITH_HYPHEN,
} from '../../shared/constants/Constants';
import { countryMobileCodes } from '../../shared/constants/CountryOptions';
import AppHidden from '../../shared/components/app-hidden/AppHidden';
import { debounce } from '../../api/apiUtils';
import { getAirportsApi } from '../../api/flightApi';
import { getUserAgentId } from '../../shared/helper-utils/localStorage';
import AppLoading from '../../shared/components/app-loading/AppLoading';
import AppAlert from '../../shared/components/app-alert/AppAlert';
import AppButton from '../../shared/components/app-button/AppButton';
import AppRadioInput from '../../shared/components/app-radio-input/AppRadioInput';
import AppDatePicker from '../../shared/components/app-date-picker/AppDatePicker';
import AppTextInput from '../../shared/components/app-text-input/AppTextInput';
import AppNumberInput from '../../shared/components/app-number-input/AppNumberInput';
import AppSelect from '../../shared/components/app-select/AppSelect';
import AppLink from '../../shared/components/app-link/AppLink';
import AppCheckBox from '../../shared/components/app-check-box/AppCheckBox';
import {
  getFareInsuarancetune,
  getInsuranceInfotune,
  sendInsuranceBookingCalltune,
} from '../../api/profileApi';
import AppAsyncSelect from '../../shared/components/app-async-select/AppAsyncSelect';

const DEBOUNCE_DELAY = 500;

const getLabelCode = (country) => {
  return (
    <div
      className="flex justify-between items-center gap-2"
      title={country.name}
    >
      <div className="flex items-center gap-1 w-[78%]">
        <img
          style={{ width: '17px', height: '15px', display: 'inline' }}
          src={`https://cdn.jsdelivr.net/gh/lipis/flag-icons/flags/4x3/${country.code.toLowerCase()}.svg`}
          alt={country.code}
        />
        <span className="text-[12px] overflow-hidden">{country.name}</span>
      </div>
      <div className="flex-shrink-0">
        <span className="text-[12px]">{country.dial_code}</span>
      </div>
    </div>
  );
};

function InsurancePagetune() {
  const intl = useIntl();
  const formattedMessage = (message) => {
    return intl.formatMessage({ id: message });
  };
  const isMobileView = CheckforMobile();
  const [selectedTab, setSelectedTab] = useState('search');
  const [isLoading, setIsLoading] = useState(false);
  const [searchTab, setSearchTab] = useState(true);
  const [resultsTab, setResultsTab] = useState(false);
  const [detailsTab, setDetailsTab] = useState(false);
  const [reviewTab, setReviewTab] = useState(false);
  const [confTab, setConfTab] = useState(false);
  const originAirportRef = useRef(null);
  const [alert, setAlert] = useState(undefined);
  const [choosenPlan, setChoosenPlan] = useState({});
  const [selectedPlan, setSelectedPlan] = useState('');
  const [hasDetails, setHasDetails] = useState(false);
  const [selectedPlanId, setSlectedPlanId] = useState('');
  const [domInt, setDomint] = useState('international');
  const destinationAirportRef = useRef(null);
  const [openPassengers, setOpenPassengers] = useState(false);
  const passengersOverlayTarget = useRef(null);
  const [defaultAirportsList, setDefaultAirportsList] = useState([]);
  const [planOptions, setPlanOptions] = useState([]);
  const [numPax, setNumPax] = useState(1);
  const [visibleOptions, setVisibleOptions] = useState([]);
  const [paymentmode, setPaymentMode] = useState('');
  const NUMPAX_DICT = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
  const [showFooter, setShowFooter] = useState(false);
  const [showTerms, setShowTerms] = useState(true);
  const [validationError, setValidationError] = useState(false);
  const [acceptTerms, setAcceptTerms] = useState(false);
  const [fareDetails, setFareDetails] = useState(null);
  const [totalInvoice, setTotalInvoice] = useState(0);

  const [selectedInsurance, setSelectedInsurance] = useState('tune');
  const targetRefs = {
    flightDetails: useRef(null),
    insurance: useRef(null),
    pax: useRef(null),
    ssr: useRef(null),
    pg: useRef(null),
  };

  const getObjectForPaxType = (paxtype) => {
    return {
      firstname: '',
      lastname: '',
      paxname: '',
      address1: '',
      address2: '',
      district: '',
      city: '',
      state: '',
      stateName: '',
      pincode: '',
      zipCode: '',
      country: '',
      phoneNum: '',
      phoneno: '',
      mobile: '',
      email: '',
      emailaddress: '',
      nominee: '',
      relation: '',
      passportnumber: '',
      age: '',
      dob: '',
      paxtype,
    };
  };

  const [paxDetails, setPaxDetails] = useState([getObjectForPaxType('Adult')]);
  const relationDropDown = [
    { label: 'Brother', value: 'Brother' },
    { label: 'Child', value: 'Child' },
    { label: 'Employer', value: 'Employer' },
    { label: 'Father', value: 'Father' },
    { label: 'Legal Heir', value: 'Legal Heir' },
    { label: 'Mother', value: 'Mother' },
    { label: 'Sister', value: 'Sister' },
    { label: 'Spouse', value: 'Spouse' },
  ];
  const [errors, setErrors] = useState({
    origin: '',
    destination: '',
    onwarddate: '',
    returndate: '',
  });

  const [search, setSearch] = useState({
    insurancesearchrequest: {
      origin: '',
      destination: '',
      onwarddate: getNewDate(TODAY_DATE),
      returndate: '',
      numadults: '1',
      numchildren: '0',
      numinfants: '0',
      requestformat: 'JSON',
      resultformat: 'JSON',
      sortkey: '',
    },
  });
  const mobileCodes = countryMobileCodes.map((country) => ({
    label: getLabelCode(country),
    value: country.dial_code,
    name: country.name,
    code: country.code,
  }));
  const [countryCodeOptions] = useState(mobileCodes);
  const [countryCode, setCountryCode] = useState('+971');
  const handleTabSelection = (tab, isDisableSelection) => {
    if (isDisableSelection) {
      return false;
    }
    setSelectedTab(tab);
  };
  const handleUpdateSearchState = (name, value) => {
    setSearch((prevState) => ({
      ...prevState,
      insurancesearchrequest: {
        ...prevState.insurancesearchrequest,
        [name]: value,
      },
    }));
    setErrors((prev) => ({
      ...prev,
      [name]: undefined,
    }));
    if (name === 'returndate') {
      setErrors((prev) => ({
        ...prev,
        onwaredDateAfterReturnDate: undefined,
      }));
    }
  };
  const tomorrow = new Date(TODAY_DATE);
  tomorrow.setDate(tomorrow.getDate() + 1);

  const handlePassengersSelection = () => {
    setOpenPassengers(false);
  };

  const handleDateChange = (date, fieldName) => {
    if (fieldName === 'returndate') {
      handleUpdateSearchState('journeytype', 'RoundTrip');
    }
    handleUpdateSearchState(fieldName, date);
  };
  const handleAirportSelect = (airport, name) => {
    if (name === 'origin') {
      originAirportRef.current = airport;
      let originAirportCode = '';
      if (airport !== null) {
        originAirportCode = airport.value;
      }
      handleUpdateSearchState('origin', originAirportCode);
    } else {
      destinationAirportRef.current = airport;
      let destinationAirportCode = '';
      if (airport !== null) {
        destinationAirportCode = airport.value;
      }
      handleUpdateSearchState('destination', destinationAirportCode);
    }
  };
  const getLabel = (airport) => {
    return (
      <>
        <AppHidden xsOnly>
          <div>
            <span
              style={{ fontSize: '16px', fontWeight: '600', color: '#1E1E1E' }}
            >
              {airport.AirportLocation.split(',')[0]}({airport.AirportCode})
            </span>
          </div>
        </AppHidden>
        <AppHidden xsDown>
          <div className="d-flex flex-column mt-1">
            <span
              style={{ fontSize: '20px', fontWeight: '600', color: '#1E1E1E' }}
            >
              {airport.AirportLocation.split(',')[0]}
            </span>
            <span
              style={{ fontSize: '16px', fontWeight: '400', color: '5B5B5B' }}
            >
              {airport.AirportCode}
            </span>
          </div>
        </AppHidden>
      </>
    );
  };
  const loadAirportSuggestions = debounce(async (query, callback) => {
    let airports = [];
    if (query.length >= 3) {
      const response = await getAirportsApi(query);
      airports = response.map((airportNode) => ({
        label: getLabel(airportNode),
        value: airportNode.AirportCode,
        ...airportNode,
      }));
    }
    callback(airports);
  }, DEBOUNCE_DELAY);

  const handleFetchAvailabilePlans = async () => {
    setIsLoading(true);
    const totalPax =
      (Number(search.insurancesearchrequest.numadults) || 0) +
      (Number(search.insurancesearchrequest.numchildren) || 0) +
      (Number(search.insurancesearchrequest.numinfants) || 0);

    setNumPax(totalPax);
    const actioncode = 'GETBAJAJPLANS';
    const res = await getInsuranceInfotune({
      actioncode,
      origin: originAirportRef.current.AirportCode,
      destination: destinationAirportRef.current.AirportCode,
      departuredate: formatDate(
        search.insurancesearchrequest.onwarddate,
        API_DATE_FORMAT,
      ),
      arrivaldate: formatDate(
        search.insurancesearchrequest.returndate,
        API_DATE_FORMAT,
      ),
      numadults: search.insurancesearchrequest.numadults,
      numchild: search.insurancesearchrequest.numchildren,
      numinfants: search.insurancesearchrequest.numinfants,
    });
    if (
      (originAirportRef.current.Country !== '' &&
        originAirportRef.current.Country.toLowerCase() !== 'india') ||
      (destinationAirportRef.current.Country !== '' &&
        destinationAirportRef.current.Country.toLowerCase() !== 'india')
    ) {
      setDomint('international');
    }
    if (res && res.ApiStatus && res.ApiStatus.Status === 'OK') {
      let { Result } = res.ApiStatus;
      Result = Array.isArray(Result) ? Result : [Result];
      //   Result.forEach((item) => {
      //     list.push({
      //       label: `${item.name}(RS ${item.premium})`,
      //       value: item.plancode,
      //       ...item,
      //     });
      //   });
      setPlanOptions(Result);
      setSelectedTab('results');
      setResultsTab(true);
      setSearchTab(false);
    } else {
      setPlanOptions([]);
      setAlert({
        variant: 'error',
        title: 'Insurance',
        description: res?.ApiStatus?.Message || 'Failed to fetch details',
      });
    }
    setIsLoading(false);
  };
  const getAge = (dob) => {
    if (dob !== '') {
      const numYears = differenceInYears(
        getNewDate(search.insurancesearchrequest.onwarddate),
        getNewDate(dob),
      );
      return numYears;
    }
    return '';
  };

  useEffect(() => {
    // Load the first 30 hotels when search results change
    setVisibleOptions(planOptions.slice(0, 30));
  }, [planOptions]);

  const loadMoreHotels = () => {
    const currentCount = visibleOptions.length;
    const newHotels = planOptions.slice(currentCount, currentCount + 30);

    // Add the next batch of hotels
    setVisibleOptions((prev) => [...prev, ...newHotels]);

    // Stop loading if we've loaded all hotels
    // if (currentCount + 30 >= searchResults.length) {
    //   setHasMore(false);
    // }
  };
  const handleUpdatePaxDetails = (name, value, index) => {
    const list = [...paxDetails];
    list[index][name] = value;
    // if (name === 'dob') {
    //   const paxAge = getAgeForPax(value);
    //   list[index].age = paxAge;
    // }
    setPaxDetails(list);
  };

  const handleUpdateState = (name, value, index = 0) => {
    if (name === 'relation') {
      setPaxDetails((prev) => ({
        ...prev,
        [index]: {
          ...prev[index],
          [name]: value.value,
          passportnumber: prev[index]?.passportnumber || '',
        },
      }));
    } else {
      setPaxDetails((prev) => ({
        ...prev,
        [index]: {
          ...prev[index],
          [name]: value,
        },
      }));
    }
  };

  const handleSetPassengers = () => {
    const adults = new Array(
      parseInt(search.insurancesearchrequest.numadults, 10),
    )
      .fill(0)
      .map(() => ({
        ...getObjectForPaxType('Adult'),
      }));
    const child = new Array(
      parseInt(search.insurancesearchrequest.numchildren, 10),
    )
      .fill(0)
      .map(() => ({
        ...getObjectForPaxType('Child'),
      }));
    const infant = new Array(
      parseInt(search.insurancesearchrequest.numinfants, 10),
    )
      .fill(0)
      .map(() => ({
        ...getObjectForPaxType('Infant'),
      }));
    const list = [...adults, ...child, ...infant];
    setPaxDetails(list);
  };
  const fetchFareDetails = async (plan) => {
    try {
      const premium = plan.PremiumAmount;
      const selectedplan = plan.PlanCode;

      const num = Math.max(...paxDetails.map((p) => Number(p.age) || 0), 1);

      const numDays = differenceInCalendarDays(
        getNewDate(search.insurancesearchrequest.returndate),
        getNewDate(search.insurancesearchrequest.onwarddate),
      );

      const fareRes = await getFareInsuarancetune({
        actioncode: 'GETTIFAREV2',
        premiumamount: premium,
        plancode: selectedplan,
        noofpax: numPax,
        agelimit: num,
        daylimit: numDays,
        agentid: getUserAgentId(),
      });

      const flightFare = fareRes?.Root?.Result?.FlightFare;
      if (flightFare) {
        setFareDetails(flightFare);
        setTotalInvoice(flightFare.InvoiceTotal || 0);
      }
    } catch (error) {
      console.error('Error fetching fare details:', error);
    }
  };
  const handlePlanSelect = async (plan) => {
    try {
      setChoosenPlan(plan);
      setSelectedPlan(plan.plancode);
      setSlectedPlanId(plan.SSRFeeCode);
      setHasDetails(true);
      handleSetPassengers();
      await fetchFareDetails(plan);

      setSelectedTab('details');
      setDetailsTab(true);
    } catch (error) {
      console.error('Error selecting plan:', error);
    }
  };
  const handlePaxDobSelect = async (date, index) => {
    const list = [...paxDetails];
    list[index].dob = date;
    const paxAge = getAge(date);
    list[index].age = paxAge;
    setPaxDetails(list);
    if (paxAge && choosenPlan) {
      await fetchFareDetails(choosenPlan);
    }
  };

  const handleSubmit = () => {
    setShowFooter(true);
  };

  const handleContinueBooking = async () => {
    setIsLoading(true);
    try {
      const list = paxDetails.map((x) => ({
        ...x,
        dob: formatDate(x.dob, API_DATE_FORMAT),
        phoneno: `${countryCode} ${x.phoneno}`,
      }));
      const bookingData = {
        ssrfeecode: choosenPlan.SSRFeeCode,
        totalpremium: choosenPlan.TotalPremiumAmount,
        origin: search.insurancesearchrequest.origin,
        destination: search.insurancesearchrequest.destination,
        departuredate: formatDate(
          search.insurancesearchrequest.onwarddate,
          API_DATE_FORMAT,
        ),
        arrivaldate: formatDate(
          search.insurancesearchrequest.returndate,
          API_DATE_FORMAT,
        ),
        numadults: search.insurancesearchrequest.numadults,
        numchild: search.insurancesearchrequest.numchildren,
        numinfants: search.insurancesearchrequest.numinfants,
        passengers: `{"passengerDetails":${JSON.stringify(list)}}`,
        plancode: choosenPlan.PlanCode,
        planname: choosenPlan.PlanTitle,
        // eslint-disable-next-line object-shorthand
        paymentmode: paymentmode,
        pgname: '',
      };
      const res = await sendInsuranceBookingCalltune(bookingData);

      if (res && res.ApiStatus && res.ApiStatus.Status === 'OK') {
        setAlert({
          variant: 'success',
          title: 'Insurance',
          description: `${res.ApiStatus.Message}`,
        });
        setTimeout(() => {
          window.location.href = `${res.ApiStatus.Result.PgUrl}?txid=${res.ApiStatus.Result.Txid}`;
        }, 2000);
      } else {
        setAlert({
          variant: 'error',
          title: 'Insurance',
          description: res?.ApiStatus?.Message || 'Failed to book Insurance',
        });
      }
    } catch (error) {
      setAlert({
        variant: 'error',
        title: 'Insurance',
        description: 'Something went wrong while booking insurance.',
      });
    } finally {
      setIsLoading(false);
    }
  };

  // const handleContinueBooking = async () => {
  //   const list = paxDetails.map((x) => ({
  //     ...x,
  //     dob: formatDate(x.dob, API_DATE_FORMAT),
  //   }));

  //   const req = {
  //     actioncode: 'PERFORMTUNEPROTECTINSURANCEBOOKING',
  //     agentid: getUserAgentId(),
  //     ssrfeecode: choosenPlan.SSRFeeCode,
  //     totalpremium: choosenPlan.TotalPremiumAmount,
  //     origin: search.insurancesearchrequest.origin,
  //     destination: search.insurancesearchrequest.destination,
  //     departuredate: formatDate(
  //       search.insurancesearchrequest.onwarddate,
  //       API_DATE_FORMAT,
  //     ),
  //     arrivaldate: formatDate(
  //       search.insurancesearchrequest.returndate,
  //       API_DATE_FORMAT,
  //     ),
  //     numadults: search.insurancesearchrequest.numadults,
  //     numchild: search.insurancesearchrequest.numchildren,
  //     numinfants: search.insurancesearchrequest.numinfants,
  //     passengers: `{"passengerDetails":${JSON.stringify(list)}}`,
  //     plancode: choosenPlan.PlanCode,
  //     planname: choosenPlan.PlanTitle,
  //   };
  //   const res = await getFinalInsuranceInfo(req);
  //   if (res && res.ApiStatus && res.ApiStatus.Status === 'OK') {
  //     setAlert({
  //       variant: 'success',
  //       title: 'Insurance',
  //       description: `${res.ApiStatus.Message}`,
  //     });
  //     setTimeout(() => {
  //       window.location.href = `${res.ApiStatus.Result.PgUrl}?txid=${res.ApiStatus.Result.Txid}`;
  //     }, 2000);
  //   } else {
  //     setAlert({
  //       variant: 'error',
  //       title: 'Insurance',
  //       description: res?.ApiStatus?.Message || 'Failed to book Insurance',
  //     });
  //   }
  //   setIsLoading(false);
  // };

  const goToReviewTab = () => {
    let isValid = true;

    paxDetails.forEach((paxDetail) => {
      if (
        isEmpty(paxDetail.paxname) ||
        isEmpty(paxDetail.address1) ||
        isEmpty(paxDetail.district) ||
        isEmpty(paxDetail.city) ||
        isEmpty(paxDetail.state) ||
        isEmpty(paxDetail.pincode) ||
        isEmpty(paxDetail.country) ||
        isEmpty(paxDetail.phoneno) ||
        isEmpty(paxDetail.mobile) ||
        isEmpty(paxDetail.emailaddress) ||
        isEmpty(paxDetail.nominee) ||
        isEmpty(paxDetail.relation) ||
        isEmpty(paxDetail.dob) ||
        paxDetail.age > 70
      ) {
        isValid = false;
        setValidationError(true);
        scrollToTop();
        return false;
      }
    });
    if (isValid) {
      setSelectedTab('review');
      setDetailsTab(false);
      setReviewTab(true);
      scrollToTop();
    }
  };

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY; // Amount the page has been scrolled vertically
      const scrollHeight = document.documentElement.scrollHeight; // Total height of the document
      const clientHeight = window.innerHeight; // Height of the visible viewport

      // Check if the user has scrolled near the bottom
      if (scrollTop + clientHeight >= scrollHeight - 100) {
        loadMoreHotels();
      }
    };

    // Attach the scroll event listener
    window.addEventListener('scroll', handleScroll);

    // Cleanup the event listener on component unmount
    return () => window.removeEventListener('scroll', handleScroll);
  }, [visibleOptions]);

  const getDobRangeByType = (type) => {
    const today = new Date();

    if (type === 'Child') {
      const maxDate = new Date();
      maxDate.setDate(today.getDate() - 1);
      const minDate = new Date();
      minDate.setFullYear(today.getFullYear() - 12);
      minDate.setDate(minDate.getDate() - 1);
      return { min: minDate, max: maxDate };
    }
    if (type === 'Infant') {
      const maxDate = today;
      maxDate.setDate(today.getDate() - 1);
      const minDate = new Date();
      minDate.setFullYear(today.getFullYear() - 2);
      return { min: minDate, max: maxDate };
    }
    if (type === 'Adult') {
      const maxDate = new Date();
      maxDate.setFullYear(today.getFullYear() - 12);
      const minDate = new Date();
      minDate.setFullYear(today.getFullYear() - 100);
      return { min: minDate, max: maxDate };
    }

    return { min: '', max: '' };
  };
  const navigationSteps = [
    { key: 'search', label: '1. Search', enabled: searchTab },
    { key: 'results', label: '2. Select Plan', enabled: resultsTab },
    { key: 'details', label: '3. Passenger Details', enabled: detailsTab },
    { key: 'review', label: '4. Review & Pay', enabled: reviewTab },
    { key: 'confirmation', label: '5. Confirmation', enabled: confTab },
  ];

  return (
    <div className="p-3 p-md-4 max-w-7xl mx-auto">
      <AppLoading isLoading={isLoading} />
      {alert && (
        <AppAlert
          showIcon
          variant={alert.variant}
          title={alert.title}
          description={alert.description}
          onHide={() => setAlert(undefined)}
        />
      )}

      <div className="bg-white rounded-3 shadow-sm border overflow-hidden">
        {/* Top Page Header */}
        <div className="bg-light px-4 py-3 border-bottom d-flex align-items-center justify-content-between">
          <div className="d-flex align-items-center gap-2">
            <h5 className="fw-bold text-dark mb-0">Tune Protect Insurance</h5>
            <span className="badge bg-primary fs-12 px-2 py-1">
              Travel Coverage
            </span>
          </div>
        </div>

        <div className="p-3 p-md-4">
          {selectedInsurance === 'tune' && (
            <div>
              {/* Multi-step Navigation Bar */}
              <div className="d-flex flex-wrap align-items-center justify-content-between gap-2 p-2 bg-light rounded-3 mb-4 border">
                {navigationSteps.map((step) => {
                  const isActive = selectedTab === step.key;
                  const isDisabled = !step.enabled;
                  let btnStyleClass = 'btn-outline-primary';
                  if (isActive) {
                    btnStyleClass = 'btn-primary text-white shadow-sm';
                  } else if (isDisabled) {
                    btnStyleClass =
                      'btn-outline-secondary text-muted opacity-50 cursor-not-allowed';
                  }

                  return (
                    <button
                      key={step.key}
                      type="button"
                      disabled={isDisabled}
                      onClick={() => handleTabSelection(step.key, isDisabled)}
                      className={`btn flex-fill text-nowrap py-2 px-3 rounded-3 fw-600 transition-all ${btnStyleClass}`}
                      style={{
                        fontSize: '13px',
                        borderWidth: isActive ? '0px' : '1px',
                      }}
                    >
                      {step.label}
                    </button>
                  );
                })}
              </div>

              {/* Tab 1: Search Form */}
              {selectedTab === 'search' && (
                <div className="bg-white p-3 p-md-4 rounded-3 border">
                  <h6 className="fw-bold text-dark mb-4 border-bottom pb-2 fs-15">
                    Search Travel Insurance Plans
                  </h6>
                  <Row className="g-3">
                    <Col lg={4} md={6} sm={12}>
                      <AppAsyncSelect
                        placeholder="Origin Airport"
                        name="origin"
                        selectedValue={originAirportRef.current}
                        loadOptionsFn={loadAirportSuggestions}
                        defaultOptions={defaultAirportsList}
                        onSelect={handleAirportSelect}
                        label="Origin"
                        menuWidth="100% !important"
                      />
                    </Col>
                    <Col lg={4} md={6} sm={12}>
                      <AppAsyncSelect
                        placeholder="Destination Airport"
                        name="destination"
                        selectedValue={destinationAirportRef.current}
                        loadOptionsFn={loadAirportSuggestions}
                        defaultOptions={defaultAirportsList}
                        onSelect={handleAirportSelect}
                        label="Destination"
                        menuWidth="100% !important"
                      />
                    </Col>
                    <Col lg={4} md={6} sm={12}>
                      <AppDatePicker
                        customClassName="app-landing-datepicker"
                        label="Departure Date"
                        placeholder="Departure Date"
                        labelClassName="landing-datepicker-label"
                        minDate={getNewDate(TODAY_DATE)}
                        monthsShown={isMobileView ? 1 : 2}
                        dateFormat="dd MMM yy"
                        selectedDate={search.insurancesearchrequest.onwarddate}
                        onChange={(date) =>
                          handleDateChange(date, 'onwarddate')
                        }
                        showDay={!isMobileView}
                        customMobileClass="mobile-search-datepicker"
                      />
                    </Col>
                    <Col lg={4} md={6} sm={12}>
                      <AppDatePicker
                        customClassName="app-landing-datepicker"
                        label="Arrival Date"
                        placeholder="Arrival Date"
                        labelClassName="landing-datepicker-label"
                        minDate={
                          !search.insurancesearchrequest.onwarddate
                            ? getNewDate(tomorrow)
                            : search.insurancesearchrequest.onwarddate
                        }
                        monthsShown={1}
                        dateFormat="dd MMM yy"
                        selectedDate={search.insurancesearchrequest.returndate}
                        onChange={(date) =>
                          handleDateChange(date, 'returndate')
                        }
                        showDay={
                          search.insurancesearchrequest.returndate !== '' &&
                          !isMobileView
                        }
                        customMobileClass="mobile-search-datepicker"
                      />
                    </Col>

                    {/* Traveller Selector Container */}
                    <Col lg={4} md={6} sm={12}>
                      <div
                        className="d-flex flex-column"
                        style={{ position: 'relative' }}
                      >
                        <label
                          className="form-label mb-1"
                          style={{
                            fontSize: '12px',
                            fontWeight: '500',
                            color: '#6c757d',
                          }}
                        >
                          Traveller(s)
                        </label>
                        <div
                          className="form-control d-flex justify-content-between align-items-center cursor-pointer bg-white px-3"
                          style={{
                            height: '48px',
                            borderRadius: '4px',
                            border: '1px solid #ced4da',
                          }}
                          ref={passengersOverlayTarget}
                          onClick={() => setOpenPassengers(!openPassengers)}
                        >
                          <span className="fs-13 fw-600 text-dark">
                            {parseInt(
                              search.insurancesearchrequest.numadults,
                              10,
                            )}{' '}
                            Adult(s)
                            {search.insurancesearchrequest.numchildren > 0 &&
                              `, ${search.insurancesearchrequest.numchildren} Child`}
                            {search.insurancesearchrequest.numinfants > 0 &&
                              `, ${search.insurancesearchrequest.numinfants} Infant`}
                          </span>
                          {openPassengers ? (
                            <MdKeyboardArrowUp size={20} />
                          ) : (
                            <MdKeyboardArrowDown size={20} />
                          )}
                        </div>

                        {/* Travellers Overlay Card */}
                        <Overlay
                          target={passengersOverlayTarget.current}
                          show={openPassengers}
                          placement="bottom-start"
                          onHide={() => setOpenPassengers(false)}
                          rootClose
                        >
                          {({
                            placement,
                            arrowProps,
                            show: _show,
                            popper,
                            ...props
                          }) => (
                            <div
                              {...props}
                              style={{
                                position: 'absolute',
                                padding: '1.25rem',
                                borderRadius: '12px',
                                width: '320px',
                                backgroundColor: '#ffffff',
                                boxShadow: '0 10px 30px rgba(0,0,0,0.15)',
                                border: '1px solid #e2e8f0',
                                zIndex: 9999,
                                ...props.style,
                              }}
                            >
                              <h6 className="fw-bold mb-3 text-dark border-bottom pb-2 fs-14">
                                Select Passengers
                              </h6>

                              {/* Adults */}
                              <div className="mb-3">
                                <div className="d-flex justify-content-between align-items-center mb-1">
                                  <span className="fs-13 fw-600 text-dark">
                                    Adults
                                  </span>
                                  <span className="fs-11 text-muted">
                                    (12+ yrs)
                                  </span>
                                </div>
                                <div className="d-flex flex-wrap gap-1">
                                  {NUMPAX_DICT.map(
                                    (pax) =>
                                      pax !== '0' && (
                                        <button
                                          key={pax}
                                          type="button"
                                          className={`btn btn-sm ${
                                            search.insurancesearchrequest
                                              .numadults === pax
                                              ? 'btn-primary fw-bold'
                                              : 'btn-outline-secondary'
                                          }`}
                                          style={{
                                            minWidth: '32px',
                                            height: '32px',
                                            padding: '2px',
                                          }}
                                          onClick={() =>
                                            handleUpdateSearchState(
                                              'numadults',
                                              pax,
                                            )
                                          }
                                        >
                                          {pax}
                                        </button>
                                      ),
                                  )}
                                </div>
                              </div>

                              {/* Children */}
                              <div className="mb-3">
                                <div className="d-flex justify-content-between align-items-center mb-1">
                                  <span className="fs-13 fw-600 text-dark">
                                    Children
                                  </span>
                                  <span className="fs-11 text-muted">
                                    (2-12 yrs)
                                  </span>
                                </div>
                                <div className="d-flex flex-wrap gap-1">
                                  {NUMPAX_DICT.map((pax) => (
                                    <button
                                      key={pax}
                                      type="button"
                                      className={`btn btn-sm ${
                                        search.insurancesearchrequest
                                          .numchildren === pax
                                          ? 'btn-primary fw-bold'
                                          : 'btn-outline-secondary'
                                      }`}
                                      style={{
                                        minWidth: '32px',
                                        height: '32px',
                                        padding: '2px',
                                      }}
                                      onClick={() =>
                                        handleUpdateSearchState(
                                          'numchildren',
                                          pax,
                                        )
                                      }
                                    >
                                      {pax}
                                    </button>
                                  ))}
                                </div>
                              </div>

                              {/* Infants */}
                              <div className="mb-3">
                                <div className="d-flex justify-content-between align-items-center mb-1">
                                  <span className="fs-13 fw-600 text-dark">
                                    Infants
                                  </span>
                                  <span className="fs-11 text-muted">
                                    (&lt;2 yrs)
                                  </span>
                                </div>
                                <div className="d-flex flex-wrap gap-1">
                                  {NUMPAX_DICT.map((pax) => (
                                    <button
                                      key={pax}
                                      type="button"
                                      className={`btn btn-sm ${
                                        search.insurancesearchrequest
                                          .numinfants === pax
                                          ? 'btn-primary fw-bold'
                                          : 'btn-outline-secondary'
                                      }`}
                                      style={{
                                        minWidth: '32px',
                                        height: '32px',
                                        padding: '2px',
                                      }}
                                      onClick={() =>
                                        handleUpdateSearchState(
                                          'numinfants',
                                          pax,
                                        )
                                      }
                                    >
                                      {pax}
                                    </button>
                                  ))}
                                </div>
                              </div>

                              <div className="d-flex justify-content-end pt-2 border-top">
                                <AppButton
                                  btnText="Done"
                                  onClick={handlePassengersSelection}
                                  variant="primary"
                                  className="px-4 py-1 fs-12"
                                />
                              </div>
                            </div>
                          )}
                        </Overlay>
                      </div>
                    </Col>

                    {/* Fetch Plans Action Button */}
                    <Col lg={4} md={6} sm={12}>
                      <div className="d-flex align-items-end h-100">
                        <AppButton
                          btnText="Fetch Available Plans"
                          variant="primary"
                          className="w-100 py-2 fs-14 fw-600"
                          style={{ height: '48px' }}
                          onClick={handleFetchAvailabilePlans}
                        />
                      </div>
                    </Col>
                  </Row>
                </div>
              )}

              {/* Tab 2: Results Form */}
              {selectedTab === 'results' && (
                <div className="bg-white p-3 p-md-4 rounded-3 border">
                  {visibleOptions.length > 0 ? (
                    <div className="d-flex flex-column gap-3">
                      <div className="d-flex justify-content-between align-items-center mb-2 pb-2 border-bottom">
                        <span className="fs-15 fw-600 text-dark">
                          Available Insurance Plans ({visibleOptions.length})
                        </span>
                        <AppButton
                          btnText="Modify Search"
                          variant="secondary"
                          className="fs-12"
                          onClick={() => {
                            setSearchTab(true);
                            setResultsTab(false);
                            setSelectedTab('search');
                          }}
                        />
                      </div>
                      {visibleOptions.map((plan) => (
                        <Card
                          key={plan.SSRFeeCode}
                          className="border shadow-sm rounded-3 hover-shadow transition"
                        >
                          <Card.Body className="p-3 p-md-4">
                            <div className="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center gap-3">
                              <div>
                                <div className="badge bg-primary text-white fw-bold mb-2 fs-12 px-2 py-1">
                                  {plan.SSRFeeCode || 'PLAN'}
                                </div>
                                <h5 className="fw-bold text-dark mb-1">
                                  {plan.PlanTitle || plan.name}
                                </h5>
                                <span className="fs-13 text-muted">
                                  Travel protection policy coverage for {numPax}{' '}
                                  passenger(s)
                                </span>
                              </div>
                              <div className="d-flex flex-row flex-md-column align-items-end justify-content-between w-100 w-md-auto gap-2 border-top border-md-0 pt-2 pt-md-0">
                                <div className="text-end">
                                  <div className="fs-12 text-muted">
                                    Per Pax:{' '}
                                    {formatCurrency(plan.PremiumAmount)}
                                  </div>
                                  <div className="fs-18 fw-bold text-success">
                                    Total:{' '}
                                    {formatCurrency(plan.TotalPremiumAmount)}
                                  </div>
                                </div>
                                <AppButton
                                  btnText="Choose Plan"
                                  variant="primary"
                                  className="px-4 py-2 fs-13 fw-600"
                                  onClick={() => handlePlanSelect(plan)}
                                />
                              </div>
                            </div>
                          </Card.Body>
                        </Card>
                      ))}
                    </div>
                  ) : (
                    <div className="text-center py-5">
                      <p className="text-muted fs-15">
                        No plans available for selected query.
                      </p>
                      <AppButton
                        btnText="Back to Search"
                        variant="primary"
                        onClick={() => setSelectedTab('search')}
                      />
                    </div>
                  )}
                </div>
              )}

              {/* Tab 3: Passenger Details */}
              {selectedTab === 'details' && (
                <div className="bg-white p-3 p-md-4 rounded-3 border">
                  <div className="d-flex justify-content-between align-items-center mb-4 pb-2 border-bottom">
                    <h5 className="fw-bold text-dark mb-0">
                      Passenger Information
                    </h5>
                    <span className="badge bg-secondary fs-12">
                      Selected Plan:{' '}
                      {choosenPlan.PlanTitle || choosenPlan.SSRFeeCode}
                    </span>
                  </div>
                  {selectedPlan !== '' && (
                    <>
                      {paxDetails.map((pax, index) => (
                        <Card
                          key={index}
                          className="border shadow-sm rounded-3 mb-4"
                        >
                          <Card.Header className="bg-light border-bottom px-4 py-3 d-flex justify-content-between align-items-center">
                            <span className="fw-bold text-dark fs-15">
                              Passenger {index + 1} ({pax.paxtype})
                            </span>
                            <span className="badge bg-primary text-white fs-12">
                              {pax.paxtype}
                            </span>
                          </Card.Header>
                          <Card.Body className="p-3 p-md-4">
                            <Row className="g-3">
                              <Col lg={3} md={4} sm={6} xs={12}>
                                <AppTextInput
                                  required
                                  name={`paxname-${index}`}
                                  label="Full Name"
                                  value={pax.paxname || ''}
                                  onChange={(e) =>
                                    handleUpdatePaxDetails(
                                      'paxname',
                                      e.target.value,
                                      index,
                                    )
                                  }
                                  errorText={
                                    validationError &&
                                    !pax.paxname &&
                                    'Please enter name'
                                  }
                                />
                              </Col>
                              <Col lg={3} md={4} sm={6} xs={12}>
                                <AppDatePicker
                                  required
                                  customClassName="app-landing-datepicker uniform-field"
                                  label="Date of Birth"
                                  placeholder="DD/MM/YYYY"
                                  labelClassName="landing-datepicker-label"
                                  monthsShown={1}
                                  dateFormat="dd MMM yyyy"
                                  selectedDate={getNewDate(pax.dob)}
                                  minDate={getDobRangeByType(pax.paxtype).min}
                                  maxDate={getDobRangeByType(pax.paxtype).max}
                                  onChange={(date) =>
                                    handlePaxDobSelect(date, index)
                                  }
                                  customMobileClass="mobile-search-datepicker"
                                  showMonthDropdown
                                  showYearDropdown
                                  dropdownMode="select"
                                />
                                {validationError && !pax.dob && (
                                  <small className="text-danger d-block mt-1 fs-12">
                                    Select birth date
                                  </small>
                                )}
                                {validationError &&
                                  pax.paxtype === 'Adult' &&
                                  pax.age > 70 && (
                                    <small className="text-danger d-block mt-1 fs-12">
                                      Adults must be under 70 years
                                    </small>
                                  )}
                              </Col>
                              <Col lg={3} md={4} sm={6} xs={12}>
                                <AppTextInput
                                  label="Age"
                                  value={pax.age || ''}
                                  readOnly
                                />
                              </Col>
                              <Col lg={3} md={4} sm={6} xs={12}>
                                <AppTextInput
                                  required
                                  name={`address1-${index}`}
                                  label="Address 1"
                                  value={pax.address1 || ''}
                                  onChange={(e) =>
                                    handleUpdatePaxDetails(
                                      'address1',
                                      e.target.value,
                                      index,
                                    )
                                  }
                                  errorText={
                                    validationError &&
                                    !pax.address1 &&
                                    'Please enter address 1'
                                  }
                                />
                              </Col>
                              <Col lg={3} md={4} sm={6} xs={12}>
                                <AppTextInput
                                  name={`address2-${index}`}
                                  label="Address 2"
                                  value={pax.address2 || ''}
                                  onChange={(e) =>
                                    handleUpdatePaxDetails(
                                      'address2',
                                      e.target.value,
                                      index,
                                    )
                                  }
                                />
                              </Col>
                              <Col lg={3} md={4} sm={6} xs={12}>
                                <AppTextInput
                                  required
                                  name={`district-${index}`}
                                  label="District"
                                  value={pax.district || ''}
                                  onChange={(e) =>
                                    handleUpdatePaxDetails(
                                      'district',
                                      e.target.value,
                                      index,
                                    )
                                  }
                                  errorText={
                                    validationError &&
                                    !pax.district &&
                                    'Please enter district'
                                  }
                                />
                              </Col>
                              <Col lg={3} md={4} sm={6} xs={12}>
                                <AppTextInput
                                  required
                                  name={`cityName-${index}`}
                                  label="City Name"
                                  value={pax.city || ''}
                                  onChange={(e) =>
                                    handleUpdatePaxDetails(
                                      'city',
                                      e.target.value,
                                      index,
                                    )
                                  }
                                  errorText={
                                    validationError &&
                                    !pax.city &&
                                    'Please enter city'
                                  }
                                />
                              </Col>
                              <Col lg={3} md={4} sm={6} xs={12}>
                                <AppTextInput
                                  required
                                  name={`stateName-${index}`}
                                  label="State Name"
                                  value={pax.state || ''}
                                  onChange={(e) =>
                                    handleUpdatePaxDetails(
                                      'state',
                                      e.target.value,
                                      index,
                                    )
                                  }
                                  errorText={
                                    validationError &&
                                    !pax.state &&
                                    'Please enter state'
                                  }
                                />
                              </Col>
                              <Col lg={3} md={4} sm={6} xs={12}>
                                <AppNumberInput
                                  required
                                  name={`zipCode-${index}`}
                                  label="Zip Code"
                                  value={pax.pincode || ''}
                                  onChange={(e) =>
                                    handleUpdatePaxDetails('pincode', e, index)
                                  }
                                  errorText={
                                    validationError &&
                                    !pax.pincode &&
                                    'Please enter zip code'
                                  }
                                />
                              </Col>
                              <Col lg={3} md={4} sm={6} xs={12}>
                                <AppTextInput
                                  required
                                  name="country"
                                  label="Country"
                                  value={pax.country || ''}
                                  onChange={(e) =>
                                    handleUpdatePaxDetails(
                                      'country',
                                      e.target.value,
                                      index,
                                    )
                                  }
                                  errorText={
                                    validationError &&
                                    !pax.country &&
                                    'Please enter country'
                                  }
                                />
                              </Col>
                              <Col
                                lg={3}
                                md={4}
                                sm={6}
                                xs={12}
                                style={{ position: 'relative', zIndex: 10 }}
                              >
                                <AppSelect
                                  className="country-codes-input"
                                  label={
                                    formattedMessage('country_code') ||
                                    'Country Code'
                                  }
                                  name="countryCode"
                                  id="countryCode"
                                  placeholder="Country Code"
                                  maxheight="200px"
                                  selectedValue={countryCode}
                                  options={countryCodeOptions}
                                  isClearable={false}
                                  isSearchable
                                  getOptionLabel={(option) => option.label}
                                  getOptionValue={(option) => option.value}
                                  filterOption={(option, inputValue) =>
                                    option?.data?.name
                                      ?.toLowerCase()
                                      ?.includes(inputValue.toLowerCase()) ||
                                    option.data.value.includes(inputValue)
                                  }
                                  onSelect={(value) =>
                                    setCountryCode(value ? value.value : '')
                                  }
                                />
                              </Col>
                              <Col lg={3} md={4} sm={6} xs={12}>
                                <AppNumberInput
                                  required
                                  name="phoneNum"
                                  label="Phone Number"
                                  value={pax.phoneno || ''}
                                  onChange={(e) =>
                                    handleUpdatePaxDetails('phoneno', e, index)
                                  }
                                  errorText={
                                    validationError &&
                                    !pax.phoneno &&
                                    'Please enter phone number'
                                  }
                                />
                              </Col>
                              <Col lg={3} md={4} sm={6} xs={12}>
                                <AppNumberInput
                                  required
                                  name="mobile"
                                  label="Mobile"
                                  value={pax.mobile || ''}
                                  onChange={(e) =>
                                    handleUpdatePaxDetails('mobile', e, index)
                                  }
                                  errorText={
                                    validationError &&
                                    !pax.mobile &&
                                    'Please enter mobile'
                                  }
                                />
                              </Col>
                              <Col lg={3} md={4} sm={6} xs={12}>
                                <AppTextInput
                                  required
                                  name="email"
                                  label="Email"
                                  value={pax.emailaddress || ''}
                                  onChange={(e) =>
                                    handleUpdatePaxDetails(
                                      'emailaddress',
                                      e.target.value,
                                      index,
                                    )
                                  }
                                  errorText={
                                    validationError &&
                                    !pax.emailaddress &&
                                    'Please enter email'
                                  }
                                />
                              </Col>
                              <Col lg={3} md={4} sm={6} xs={12}>
                                <AppTextInput
                                  required
                                  name="nominee"
                                  label="Nominee"
                                  value={pax.nominee || ''}
                                  onChange={(e) =>
                                    handleUpdatePaxDetails(
                                      'nominee',
                                      e.target.value,
                                      index,
                                    )
                                  }
                                  errorText={
                                    validationError &&
                                    !pax.nominee &&
                                    'Please enter nominee'
                                  }
                                />
                              </Col>
                              <Col
                                lg={3}
                                md={4}
                                sm={6}
                                xs={12}
                                style={{ position: 'relative', zIndex: 10 }}
                              >
                                <AppSelect
                                  selectedValue={pax.relation || ''}
                                  options={relationDropDown}
                                  isClearable={false}
                                  required
                                  onSelect={(e) =>
                                    handleUpdatePaxDetails(
                                      'relation',
                                      e ? e.value : '',
                                      index,
                                    )
                                  }
                                  label="Relation"
                                  errorText={
                                    validationError &&
                                    !pax.relation &&
                                    'Select relation'
                                  }
                                />
                              </Col>
                              <Col lg={3} md={4} sm={6} xs={12}>
                                <AppTextInput
                                  required={domInt === 'international'}
                                  name="passportnumber"
                                  label="Passport Number"
                                  value={pax.passportnumber || ''}
                                  onChange={(e) =>
                                    handleUpdatePaxDetails(
                                      'passportnumber',
                                      e.target.value,
                                      index,
                                    )
                                  }
                                  errorText={
                                    validationError &&
                                    domInt === 'international' &&
                                    !pax.passportnumber &&
                                    'Please enter passport'
                                  }
                                />
                              </Col>
                            </Row>
                          </Card.Body>
                        </Card>
                      ))}

                      <div className="d-flex justify-content-center mt-3">
                        <AppButton
                          btnText="Proceed to Booking Review"
                          variant="primary"
                          className="px-5 py-2 fs-14 fw-600"
                          onClick={goToReviewTab}
                        />
                      </div>
                    </>
                  )}
                </div>
              )}

              {/* Tab 4: Review Form */}
              {selectedTab === 'review' && (
                <div className="bg-white p-3 p-md-4 rounded-3 border">
                  <div className="d-flex justify-content-between align-items-center mb-4 pb-2 border-bottom">
                    <div>
                      <h5 className="fw-bold text-dark mb-1">
                        Insurance Review Summary
                      </h5>
                      <span className="fs-13 text-muted">
                        Plan:{' '}
                        {choosenPlan.PlanTitle ||
                          choosenPlan.name ||
                          choosenPlan.SSRFeeCode}
                      </span>
                    </div>
                    <AppButton
                      btnText="Edit Passenger Details"
                      variant="secondary"
                      className="fs-12"
                      onClick={() => setSelectedTab('details')}
                    />
                  </div>

                  <Row className="g-4">
                    {/* Passenger Details Left Column */}
                    <Col lg={8} md={12}>
                      <div className="d-flex flex-column gap-3">
                        {paxDetails.map((pax, index) => (
                          <Card
                            key={index}
                            className="border shadow-sm rounded-3"
                          >
                            <Card.Header className="bg-light px-4 py-2.5 fw-bold text-dark fs-14 border-bottom d-flex justify-content-between align-items-center">
                              <span>
                                Passenger {index + 1} ({pax.paxtype})
                              </span>
                              <span className="badge bg-primary fs-11">
                                {pax.paxname || 'Details'}
                              </span>
                            </Card.Header>
                            <Card.Body className="p-3 p-md-4">
                              <Row className="g-2 fs-13">
                                <Col sm={6} xs={12}>
                                  <div className="p-2 rounded bg-light mb-1">
                                    <span className="text-muted d-block fs-11">
                                      Name
                                    </span>
                                    <strong className="text-dark">
                                      {pax.paxname || '-'}
                                    </strong>
                                  </div>
                                </Col>
                                <Col sm={6} xs={12}>
                                  <div className="p-2 rounded bg-light mb-1">
                                    <span className="text-muted d-block fs-11">
                                      Relation to Insured
                                    </span>
                                    <strong className="text-dark">
                                      {pax.relation || '-'}
                                    </strong>
                                  </div>
                                </Col>
                                <Col sm={6} xs={12}>
                                  <div className="p-2 rounded bg-light mb-1">
                                    <span className="text-muted d-block fs-11">
                                      Date of Birth
                                    </span>
                                    <strong className="text-dark">
                                      {pax.dob
                                        ? formatDate(
                                            getNewDate(pax.dob),
                                            DATE_MONTH_YEAR_WITH_HYPHEN,
                                          )
                                        : '-'}
                                    </strong>
                                  </div>
                                </Col>
                                <Col sm={6} xs={12}>
                                  <div className="p-2 rounded bg-light mb-1">
                                    <span className="text-muted d-block fs-11">
                                      Beneficiary (Nominee)
                                    </span>
                                    <strong className="text-dark">
                                      {pax.nominee || '-'}
                                    </strong>
                                  </div>
                                </Col>
                                <Col sm={6} xs={12}>
                                  <div className="p-2 rounded bg-light mb-1">
                                    <span className="text-muted d-block fs-11">
                                      Passport Number
                                    </span>
                                    <strong className="text-dark">
                                      {pax.passportnumber || 'N/A'}
                                    </strong>
                                  </div>
                                </Col>
                                <Col sm={6} xs={12}>
                                  <div className="p-2 rounded bg-light mb-1">
                                    <span className="text-muted d-block fs-11">
                                      Mobile
                                    </span>
                                    <strong className="text-dark">
                                      {pax.mobile || '-'}
                                    </strong>
                                  </div>
                                </Col>
                                <Col sm={6} xs={12}>
                                  <div className="p-2 rounded bg-light mb-1">
                                    <span className="text-muted d-block fs-11">
                                      Email
                                    </span>
                                    <strong className="text-dark">
                                      {pax.emailaddress || '-'}
                                    </strong>
                                  </div>
                                </Col>
                                <Col sm={6} xs={12}>
                                  <div className="p-2 rounded bg-light mb-1">
                                    <span className="text-muted d-block fs-11">
                                      Location
                                    </span>
                                    <strong className="text-dark">
                                      {pax.city
                                        ? `${pax.city}, ${pax.state}, ${pax.country}`
                                        : '-'}
                                    </strong>
                                  </div>
                                </Col>
                              </Row>
                            </Card.Body>
                          </Card>
                        ))}
                      </div>
                    </Col>

                    {/* Fare Breakdown & Payment Method Right Column */}
                    <Col lg={4} md={12}>
                      <div className="d-flex flex-column gap-3">
                        {/* Fare Breakdown Invoice Card */}
                        {fareDetails && (
                          <Card className="border shadow-sm rounded-3">
                            <Card.Header className="bg-light px-4 py-3 fw-bold text-dark fs-14 border-bottom">
                              Fare Breakdown
                            </Card.Header>
                            <Card.Body className="p-3 fs-13">
                              <div className="d-flex justify-content-between py-1">
                                <span className="text-muted">Base Fare:</span>
                                <span className="fw-600">
                                  {formatCurrency(fareDetails.BaseFare || 0)}
                                </span>
                              </div>
                              <div className="d-flex justify-content-between py-1">
                                <span className="text-muted">
                                  Handling Charges:
                                </span>
                                <span className="fw-600">
                                  {formatCurrency(
                                    fareDetails.HandlingCharges || 0,
                                  )}
                                </span>
                              </div>
                              <div className="d-flex justify-content-between py-1">
                                <span className="text-muted">Service Tax:</span>
                                <span className="fw-600">
                                  {formatCurrency(fareDetails.ServiceTax || 0)}
                                </span>
                              </div>
                              <div className="d-flex justify-content-between py-1">
                                <span className="text-muted">Tax:</span>
                                <span className="fw-600">
                                  {formatCurrency(fareDetails.Tax || 0)}
                                </span>
                              </div>
                              <div className="d-flex justify-content-between py-1">
                                <span className="text-muted">Commission:</span>
                                <span className="fw-600">
                                  {formatCurrency(fareDetails.Commission || 0)}
                                </span>
                              </div>
                              <hr className="my-2" />
                              <div className="d-flex justify-content-between py-2 fs-15 fw-bold text-primary">
                                <span>Total Invoice:</span>
                                <span>{formatCurrency(totalInvoice)}</span>
                              </div>
                            </Card.Body>
                          </Card>
                        )}

                        {/* Payment Options Card */}
                        <Card
                          className="border shadow-sm rounded-3"
                          ref={targetRefs.pg}
                        >
                          <Card.Header className="bg-light px-4 py-3 fw-bold text-dark fs-14 border-bottom">
                            Payment Options
                          </Card.Header>
                          <Card.Body className="p-3">
                            <div className="d-flex flex-column gap-2">
                              <div
                                className={`p-3 rounded-3 border cursor-pointer d-flex align-items-center gap-3 transition-all ${
                                  paymentmode === 'cashcard'
                                    ? 'border-primary bg-primary-subtle text-primary fw-bold shadow-sm'
                                    : 'bg-light text-dark'
                                }`}
                                onClick={() => setPaymentMode('cashcard')}
                              >
                                <CiWallet size={24} />
                                <div>
                                  <div className="fs-14">Wallet</div>
                                  <div className="fs-11 text-muted">
                                    Pay via Agent Wallet
                                  </div>
                                </div>
                              </div>

                              <div
                                className={`p-3 rounded-3 border cursor-pointer d-flex align-items-center gap-3 transition-all ${
                                  paymentmode === 'creditcard'
                                    ? 'border-primary bg-primary-subtle text-primary fw-bold shadow-sm'
                                    : 'bg-light text-dark'
                                }`}
                                onClick={() => setPaymentMode('creditcard')}
                              >
                                <MdOutlineCreditCard size={24} />
                                <div>
                                  <div className="fs-14">Credit Card</div>
                                  <div className="fs-11 text-muted">
                                    Pay with Credit Card
                                  </div>
                                </div>
                              </div>

                              <div
                                className={`p-3 rounded-3 border cursor-pointer d-flex align-items-center gap-3 transition-all ${
                                  paymentmode === 'debitcard'
                                    ? 'border-primary bg-primary-subtle text-primary fw-bold shadow-sm'
                                    : 'bg-light text-dark'
                                }`}
                                onClick={() => setPaymentMode('debitcard')}
                              >
                                <MdOutlineCreditCard size={24} />
                                <div>
                                  <div className="fs-14">Debit Card</div>
                                  <div className="fs-11 text-muted">
                                    Pay with Debit Card
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div className="mt-3 text-center">
                              {getEligibilityForPaymentMode('book') && (
                                <AppButton
                                  btnText="Proceed to Confirmation"
                                  variant="primary"
                                  className="w-100 py-2 fs-14 fw-600"
                                  onClick={handleSubmit}
                                />
                              )}
                            </div>
                          </Card.Body>
                        </Card>

                        {/* Terms & Final Action */}
                        {showFooter && (
                          <Card className="border shadow-sm rounded-3 bg-light">
                            <Card.Body className="p-3">
                              <div className="d-flex justify-content-between align-items-center mb-2">
                                <span className="fs-13 fw-bold text-dark">
                                  Terms & Conditions
                                </span>
                                <AppLink
                                  linkText={
                                    showTerms ? 'Hide Terms' : 'Show Terms'
                                  }
                                  className="fs-12 text-primary"
                                  onClick={() => setShowTerms((prev) => !prev)}
                                />
                              </div>
                              {showTerms && (
                                <div className="fs-12 text-muted mb-3 bg-white p-2 rounded border">
                                  I declare that all information provided in
                                  this insurance application is accurate, true,
                                  and complete to the best of my knowledge.
                                </div>
                              )}
                              <div className="d-flex flex-column gap-3">
                                <AppCheckBox
                                  labelText="I agree to the Terms & Conditions"
                                  id="acceptTerms"
                                  name="acceptTerms"
                                  checked={acceptTerms}
                                  labelClassName="fs-12 fw-500 text-dark"
                                  onChange={() =>
                                    setAcceptTerms((prev) => !prev)
                                  }
                                />
                                <AppButton
                                  btnText="Continue Booking Insurance"
                                  variant="primary"
                                  className="w-100 py-2 fs-14 fw-bold"
                                  disabled={!acceptTerms || isLoading}
                                  onClick={handleContinueBooking}
                                />
                              </div>
                            </Card.Body>
                          </Card>
                        )}
                      </div>
                    </Col>
                  </Row>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default InsurancePagetune;
